import { createFileRoute, Outlet } from '@tanstack/react-router';
import { DocLayout } from '../components/documentation/DocLayout';

export const Route = createFileRoute('/documentation')({
  component: DocumentationLayout,
});

function DocumentationLayout() {
  return (
    <DocLayout>
      <Outlet />
    </DocLayout>
  );
}
